<script>
import "./vfigma.input.scss";

export default {
  // props: ["input", "placeholder", "disabled", "enter", "esc", "optional", "focus", "change"],
  props: {
    disabled: Boolean,
    enter: Function,
    esc: Function,
    optional: Boolean,
    focus: Function,
    title: String,
    date: Date,
    click: Function,
    readonly: Boolean,
    error: Boolean,
  },
  data() {
    return {
      value: "",
      focused: false,
      input: "",
    };
  },
  methods: {
    onInput(datetimeString) {
      this.$emit("update:date", new Date(datetimeString));
    },
  },
  computed: {
    formattedDate() {
      const date = this.date;
      if (!date) return "";
      const pad = (n) => n.toString().padStart(2, "0");
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
  },
  mounted: function () {},
  watch: {},
};
</script>

<template>
  <div class="f-date">
    <f-field :optional="optional" :focused="focused">
      <template v-slot:label><slot name="label"></slot></template>
      <template v-slot:content>
        <div
          class="f-input-container"
          :class="{ focus: focused, error: error }"
        >
          <input
            ref="inputDate"
            type="datetime-local"
            class="keepfocus f-input"
            :value="formattedDate"
            @input="onInput($event.target.value)"
            :disabled="disabled"
            :readonly="readonly"
            :title="title"
          />
        </div>
      </template>
      <template v-slot:helper v-if="$slots.helper"
        ><slot name="helper"></slot
      ></template>
    </f-field>
  </div>
</template>

<style scoped lang="scss">
</style>